import React, { useState } from 'react';
import { DateRangePicker, Calendar } from 'react-date-range';
import { FormControlLabel, Fab, Switch, Grid, Typography } from '@material-ui/core';
import { dateToYmdStr, useRecentGetter, useToggle } from '@lib/common';
import { useCallback } from 'react';
import FilterIcon from '@material-ui/icons/FilterList';
import { $eq, $bw } from '../operators';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Slider from '@material-ui/core/Slider';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  input: {
    width: 60,
  },
});
export function withRangeFilters<T>(
  minRange: number,
  maxRange: number,
  minDefault: number,
  maxDefault: number
) {
  return function RangeFilters({ column: { setFilter, filterValue }, closeFilter }) {
    const classes = useStyles();
    const [value, setValue] = React.useState<number[]>([minDefault, maxDefault]);

    const handleGTInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue(oldState => [
        event.target.value === '' ? 0 : Number(event.target.value),
        oldState[1],
      ]);
    };

    const handleLTInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue(oldState => [
        oldState[0],
        event.target.value === '' ? 0 : Number(event.target.value),
      ]);
    };

    const handleChange = (event: any, newValue: number | number[]) => {
      setValue(newValue as number[]);
    };
    const getFilterValue = useRecentGetter(filterValue);

    const applyFilter = useCallback(() => {
      const filter = {
        [$bw.key]: value,
      };
      setFilter({
        ...getFilterValue(),
        ...filter,
      });
      closeFilter();
    }, [closeFilter, value]);

    return (
      <div className={classes.root}>
        {/* <Typography id="range-slider" gutterBottom>
        Release Year
      </Typography> */}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Slider
              value={value}
              onChange={handleChange}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
              min={minRange}
              max={maxRange}
            />
          </Grid>

          <Grid item xs style={{ display: 'flex', textAlign: 'center' }}>
            <Input
              className={classes.input}
              value={value[0]}
              margin="dense"
              style={{ marginRight: '10px' }}
              onChange={handleGTInputChange}
              inputProps={{
                type: 'number',
                'aria-labelledby': 'input-slider',
              }}
            />
            <Typography style={{ marginTop: '5px' }}>-</Typography>
            <Input
              className={classes.input}
              value={value[1]}
              margin="dense"
              style={{ marginLeft: '10px' }}
              onChange={handleLTInputChange}
              inputProps={{
                type: 'number',
                'aria-labelledby': 'input-slider',
              }}
            />
            <Fab color="primary" style={{ marginLeft: '10px' }} size="small" onClick={applyFilter}>
              <FilterIcon />
            </Fab>
          </Grid>
        </Grid>
      </div>
    );
  };
}
